/* Sticky CTA — Show/hide on scroll + IntersectionObserver */
(function() {
  'use strict';

  var bar = document.querySelector('[data-sticky-cta]');
  if (!bar) return;

  var buyBox = document.querySelector('.buy-box');
  var productHero = document.querySelector('.product-hero');
  var isVisible = false;

  function update() {
    if (!productHero) return;

    var heroRect = productHero.getBoundingClientRect();
    var buyBoxVisible = false;

    if (buyBox) {
      var buyBoxRect = buyBox.getBoundingClientRect();
      buyBoxVisible = buyBoxRect.top < window.innerHeight && buyBoxRect.bottom > 0;
    }

    /* Show when scrolled past hero and buy box not visible */
    var shouldShow = heroRect.bottom < 0 && !buyBoxVisible;

    if (shouldShow && !isVisible) {
      bar.classList.add('is-visible');
      isVisible = true;
    } else if (!shouldShow && isVisible) {
      bar.classList.remove('is-visible');
      isVisible = false;
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  update();

  /* Update price when variant changes */
  var priceEl = bar.querySelector('[data-sticky-cta-price]');
  if (priceEl) {
    document.addEventListener('click', function(e) {
      var option = e.target.closest('.variant-selector__option');
      if (option) {
        var price = parseInt(option.dataset.price);
        priceEl.textContent = '$' + (price / 100).toFixed(2);
      }
    });
  }
})();
